import { render } from "./list-chat.vue?vue&type=template&id=8e27594c"
import script from "./list-chat.vue?vue&type=script&lang=js"
export * from "./list-chat.vue?vue&type=script&lang=js"

import "./list-chat.vue?vue&type=style&index=0&id=8e27594c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__